import { JoinClassName } from '../utils/cssHelper';
import CSSStyle from './index.module.css';
import React, { useCallback } from "react";

export type PaymentMethodSelectorProps = {
    onCancel: () => void;
    applyPayEnable: boolean;
    onPaymentMethodChanged: (type: 'ApplyPay' | 'Card') => void;
}
export default function PaymentMethodSelector(props: PaymentMethodSelectorProps) {
    let { applyPayEnable } = props;
    let onCancel = useCallback(() => {
        props.onCancel();
    }, [props]);

    let onSelectedPaymentMethod = useCallback((type: 'ApplyPay' | 'Card') => {
        props.onPaymentMethodChanged(type);
    }, [props])

    return (
        <div className={JoinClassName(CSSStyle.main)}>
            {/* 支付方式切换 */}
            <div className={JoinClassName(CSSStyle.header)} >
                <div className={JoinClassName(CSSStyle.cancle_operator)} onClick={onCancel}>取消</div>
                选择支付方式
            </div>
            <div className={JoinClassName(CSSStyle.payment_methods)} >
                <div className={JoinClassName(CSSStyle.payment_method)} onClick={() => onSelectedPaymentMethod('Card')}>
                    <div className={JoinClassName(CSSStyle.payment_method_icon, CSSStyle.normal_credit_card)} ></div>
                    <div className={JoinClassName(CSSStyle.payment_method_desc)} >信用卡或借记卡</div>
                </div>
                {
                    applyPayEnable && <div className={JoinClassName(CSSStyle.payment_method)} onClick={() => onSelectedPaymentMethod('ApplyPay')}>
                        <div className={JoinClassName(CSSStyle.payment_method_icon, CSSStyle.apply_pay)} ></div>
                        <div className={JoinClassName(CSSStyle.payment_method_desc)} >Apple Pay</div>
                    </div>
                }
            </div>
        </div>
    );
}